import { type ReactNode } from "react";

interface StepCardProps {
  className?: string;
  /** Step label, e.g. "Шаг 1" */
  step: string;
  /** Step title */
  title: string;
  /** Step description */
  description: string;
  /** Illustration content — any JSX for the visual part */
  children?: ReactNode;
}

/** Card for «Как это работает» section — 3 steps with illustrations */
export function StepCard({ className = "", step, title, description, children }: StepCardProps) {
  return (
    <div
      className={`relative bg-white flex flex-col gap-[16px] h-[370px] p-[20px] rounded-[16px] flex-1 max-desktop:flex-none max-desktop:w-[400px] max-desktop:shrink-0 max-desktop:snap-start max-tablet:w-full max-tablet:shrink transition-shadow hover:shadow-[0px_0px_10px_rgba(0,0,0,0.07)] ${className}`}
    >
      {/* Top: step number + title */}
      <div className="flex items-start shrink-0 w-full">
        <div className="flex flex-1 flex-col gap-[4px] items-start justify-center min-w-0">
          <span
            className="[font-family:var(--font-commissioner)] font-medium not-italic text-[16px] leading-[20px] text-[rgba(0,0,0,0.6)] text-center whitespace-nowrap"
            style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
          >
            {step}
          </span>
          <span
            className="[font-family:var(--font-commissioner)] font-bold not-italic text-[24px] leading-[28px] text-black tracking-[-0.48px]"
            style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
          >
            {title}
          </span>
        </div>
      </div>

      {/* Description */}
      <p
        className="[font-family:var(--font-commissioner)] font-medium not-italic text-[16px] leading-[24px] text-[rgba(0,0,0,0.8)]"
        style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
      >
        {description}
      </p>

      {/* Illustration area */}
      {children}
    </div>
  );
}
